import { Typography } from "antd";
import { useTranslation } from "react-i18next";

const SingleAppCardMobile = ({ app, handleClick }) => {
    const { t } = useTranslation();
    const description = t(`apps.${app.value}.short_description`);

    return (
        <div
            onClick={() => handleClick(app)}
            style={{
                padding: "10px",
                cursor: "pointer",
                display: "flex",
                width: "100%",
                alignItems: "center",
                flexDirection: "column",

                gap: "10px",
            }}>
            <Typography.Title level={1}>{app.label}</Typography.Title>

            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "200px",
                }}>
                <div
                    style={{
                        width: "200px",
                    }}>
                    <img src={app.img} alt="app" style={{ width: "100%", height: "auto" }} />
                </div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                <div>
                    <p>{description}</p>
                </div>
            </div>
        </div>
    );
};

export { SingleAppCardMobile };
